import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    { icon: 'ri-message-3-line', num: '1' },
    { icon: 'ri-search-line', num: '2' },
    { icon: 'ri-tools-line', num: '3' },
    { icon: 'ri-shield-check-line', num: '4' },
  ];

  return (
    <section className="py-10 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-primary-500 border border-primary-500/40 rounded-full px-4 py-1 mb-4">
          {t('howItWorks.label')}
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-14">
          {t('howItWorks.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => {
            const stepKey = (i + 1) as 1 | 2 | 3 | 4;
            return (
              <div
                key={i}
                className="group relative bg-background-400/60 border border-primary-500/25 hover:border-primary-500/50 rounded-2xl px-6 py-8 text-center flex flex-col items-center cursor-pointer transition-all duration-300"
              >
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-500 text-black text-xs font-extrabold w-6 h-6 rounded-full flex items-center justify-center">
                  {step.num}
                </div>
                <div className="w-14 h-14 flex items-center justify-center rounded-full mt-2 mb-4 bg-background-300 group-hover:bg-background-400 transition-colors">
                  <i className={`${step.icon} text-primary-500 text-2xl w-8 h-8 flex items-center justify-center`} />
                </div>
                <h3 className="font-bold text-base mb-2 text-white">
                  {t(`howItWorks.steps.${stepKey}.title`)}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-400">
                  {t(`howItWorks.steps.${stepKey}.desc`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}